import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {FieldInstance} from "@/shared/models/form/fields";
import {Tag} from "@/shared/ui/data-display/tags/tag-base";
import {TextField} from "@/shared/ui/form/fields";
import {assetPath} from "@/shared/utils/asset-path";

import {BlogTagsSlider} from "./blog-tags-slider";

interface PopularPostsFiltersProps {
    showTagSlider: boolean;
    hasTags: boolean;
    tags: ReadonlyArray<Tag>;
    activeTag?: string;
    onTagChange?: (tag: string) => void;
    showSearch: boolean;
    searchModel?: FieldInstance;
}

export function PopularPostsFilters({
    showTagSlider,
    hasTags,
    tags,
    onTagChange,
    showSearch,
    searchModel,
}: PopularPostsFiltersProps): JSX.Element | null {
    const showFilters = (showTagSlider && hasTags) || showSearch;

    if (!showFilters) {
        return null;
    }
    return (
        <div className="popular-posts__filters">
            <div className="popular-posts__filters-left">
                {showTagSlider && hasTags && onTagChange && <BlogTagsSlider tags={tags} onTagChange={onTagChange} />}
            </div>

            {showSearch && searchModel && (
                <div className="popular-posts__search">
                    <TextField
                        height="small"
                        fontSize="small"
                        fontWeight="medium"
                        model={searchModel}
                        placeholder="Search Blogs"
                        className="popular-posts__search-field"
                        icon={<SmartImage src={assetPath("/images/icons/search.svg")} alt="Search" width={18} height={18} />}
                        iconPosition="left"
                    />
                </div>
            )}
        </div>
    );
}
